import { ChangeEvent, useState } from 'react';
import { IconButton, InputAdornment, Stack } from '@mui/material';
import { Search } from '@mui/icons-material';
import { useDebounce } from '@shared';
import { TextField, Pagination } from './ImagaPagination.styled';

interface TypeProps {
  page: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const ImagePagination = ({ page, totalPages, onPageChange }: TypeProps) => {
  const [value, setValue] = useState('');
  const handlePageChange = (_: ChangeEvent<unknown>, page: number) => {
    onPageChange(page);
  };

  useDebounce(value, 1000, () => value && onPageChange(+value));

  return (
    <Stack position='absolute' bottom={10} sx={{ width: 900 }}>
      <Stack direction='row' spacing={2} alignItems='center' margin='0 auto'>
        <Pagination count={totalPages} page={page} onChange={handlePageChange} />
        <TextField
          type='number'
          size='small'
          label='Jump to'
          InputProps={{
            endAdornment: (
              <InputAdornment position='end'>
                <IconButton disabled={!value} onClick={(e) => handlePageChange(e, +value)}>
                  <Search htmlColor='white' />
                </IconButton>
              </InputAdornment>
            ),
          }}
          value={value}
          onChange={({ target: { value } }) =>
            ((+value <= totalPages && +value >= 1) || value === '') && setValue(value)
          }
          InputLabelProps={{ style: { color: 'white', borderColor: 'white' } }}
        />
      </Stack>
    </Stack>
  );
};
